// normalizers
import { roomParseResource } from "../room";

export default function customerParseResource({ data, configuration }) {
  return {
    id: data?.id,
    reference: data?.reference,
    state: data?.state,
    nature: data?.nature,
    source: data?.source,
    channelId: data?.channelId,
    workflow: data?.workflow,
    isOack: data?.isOack ?? false,
    oackState: data?.oackState ?? null,
    oacked: data?.oacked ?? false,
    room: roomParseResource({ data: data?.room, configuration }),
    checkin: data?.checkin,
    checkout: data?.checkout,
    departure: data?.departure,
    arrival: data?.arrival,
    tripAmount: data?.tripAmount,
    soldedAmount: data?.soldedAmount,
    insuranceAmount: data?.insuranceAmount,
    serviceFeeAmount: data?.serviceFeeAmount,
    customerPeriodsAmountWithoutDiscounts:
      data?.metas?.customerPeriodsAmountWithoutDiscounts,
    baseServiceFeeAmount: data?.baseServiceFeeAmount,
    touristTaxAmount: data?.touristTaxAmount,
    balance: data?.metas?.balance,
    duration: data?.metas?.duration,
    periodsAmountWithoutDiscounts: data?.metas?.periodsAmountWithoutDiscounts,
    discountsAmount: data?.discountsAmount,
    discountList: (data?.discounts ?? []).map((discount) => ({
      name: discount.name,
      code: discount.code,
    })),
    optionList: data?.options ?? [],
    discountServiceFeeAmount: data?.discountServiceFeeAmount,
    advanceAmount: data?.metas?.advance?.amount,
    advanceMaxDueDate: data?.metas?.advance?.dueDate,
    adults: data?.adults,
    childs: data?.childs,
    babies: data?.babies,
    pets: data?.pets,
    cats: data?.cats,
    dogs: data?.dogs,
    created: data?.created,
    paymentList: (data?.payments ?? []).map((payment) => {
      return {
        amount: Number(payment?.amount),
        date: payment?.date,
        state: payment?.state,
        type: payment?.type,
        method: payment?.method,
      };
    }),
    metas: {
      balance: Number(data?.metas?.balance),
      discount: Number(data?.metas?.discount),
      nextPayment: {
        dueDate: data?.metas?.nextPayment?.dueDate,
        amount: data?.metas?.nextPayment?.amount,
        methodList: Object.values(data?.metas?.nextPayment?.methods ?? {}),
      },
      ancvConnectAuthorizedTransactionStatus:
        data?.metas?.ancvConnectAuthorizedTransactionStatus,
      customerDiscountsAmount: data?.metas?.customerDiscountsAmount,
      insuranceBaseAmount: data?.metas?.insuranceBaseAmount,
    },
  };
}
